import { openBlock as n, createElementBlock as p, normalizeClass as t, createElementVNode as f, resolveComponent as _, createBlock as s, Transition as m, withCtx as u, renderSlot as S } from "vue";
import { _ as i } from "./_plugin-vue_export-helper-hUChTQA_.js";
const y = {
  props: {
    position: {
      type: String,
      default: "center"
    },
    size: {
      type: String,
      default: ""
    }
  }
};
function g(o, a, e, r, c, l) {
  return n(), p("div", {
    class: t(["d-flex", `justify-content-${e.position}`])
  }, [
    f("div", {
      class: t(["spinner", {
        [`spinner--size-${e.size}`]: e.size
      }])
    }, null, 2)
  ], 2);
}
const V = /* @__PURE__ */ i(y, [["render", g], ["__scopeId", "data-v-2216b0ae"]]), $ = {
  components: {
    VSpinner: V
  },
  props: {
    name: {
      type: String,
      default: "fade"
    },
    position: {
      type: String,
      default: "center"
    },
    loaderClass: {
      type: String,
      default: ""
    },
    isLoading: Boolean
  }
};
function k(o, a, e, r, c, l) {
  const d = _("VSpinner");
  return n(), s(m, {
    name: e.name,
    mode: "out-in"
  }, {
    default: u(() => [
      e.isLoading ? (n(), s(d, {
        key: 0,
        position: e.position,
        class: t(e.loaderClass)
      }, null, 8, ["position", "class"])) : S(o.$slots, "default", { key: 1 })
    ]),
    _: 3
  }, 8, ["name"]);
}
const C = /* @__PURE__ */ i($, [["render", k]]);
export {
  C as V,
  V as a
};
